import { useTranslation } from 'react-i18next'

import { OrderOnlineList } from '@widgets/order-online-list'

import Wrapper from '@shared/ui/wrapper'

import styles from './styles.module.scss'

export default function OnlineOrdersPage () {
  const { t: p } = useTranslation('personal')
  return (
    <div className={styles.root}>
      <Wrapper className={styles.root__wrapper}>
        <h2 className={styles.root__title}>{p('nav.online-orders')}</h2>
      </Wrapper>
      <OrderOnlineList />
    </div>
  )
}
